// Vendor imports
const qs = require('qs')
// Client lib imports
const { send: ajax } = require('client/lib/request')

const API = {

  fetchInterests: async function (urlHash) {
    if (!urlHash) {
      throw new Error('Article `hash` is required to fetch interests')
    }
    const interests = []
    const {
      url: { topics, categories }
    } = await ajax({ url: `/api/v0.2/url/${urlHash}` })
    if (topics) {
      topics.forEach(topic => {
        interests.push({ ...topic, type: 'interest' })
      })
    }
    if (categories) {
      categories.forEach(category => {
        interests.push({ ...category, type: 'category' })
      })
    }
    return { interests }
  },

  fetchUrlMixHistoryV2: async function (urlId, options = {}) {
    if (!urlId) {
      throw new Error('`urlId` is required')
    }
    const { nextUrl, page, limit } = options
    const url = nextUrl || `/api/v0.2/url/mixes/${urlId}/history/${page || 1}`
    const query = qs.stringify({ limit })
    return ajax({
      url: `${url}?${query}`,
      method: 'get'
    })
  },

  fetchRelatedArticles: async function (urlId, options = {}) {
    if (!urlId) {
      throw new Error('`urlId` is required')
    }
    const { nextUrl, page, limit, recBatchId } = options
    const url = nextUrl || `/api/v0.1/url/${urlId}/related/${page || 1}`
    const query = qs.stringify({ limit, recBatchId })
    return ajax({
      url: `${url}?${query}`,
      method: 'get'
    })
  }
}

module.exports = { API }
